import { render, staticRenderFns } from "./PaymentMX.vue?vue&type=template&id=38c71dd9&scoped=true"
import script from "./PaymentMX.vue?vue&type=script&lang=js"
export * from "./PaymentMX.vue?vue&type=script&lang=js"
import style0 from "./PaymentMX.vue?vue&type=style&index=0&id=38c71dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c71dd9",
  null
  
)

export default component.exports